import React from 'react'
import "./Footer.css"

export default function Footer() {
    return (
        <footer>
            <div className="footer-content">
                <div className="logo">
                    <img width={"282px"} src="/assets/vitaly.webp" alt="Logo vitaly" />
                </div>

                <div className="footer-search">
                    Contáctanos

                    <div className="call-btn">
                        <input type="text" placeholder='Ingresa tu correo' />

                        <button className="btn btn-secondary">
                            <img src="/assets/icons/right-arrow.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="fringe">
                <span>© 2024 Vitaly. Todos los derechos reservados</span>
            </div>
        </footer>
    )
}
